module.exports = __webpack_public_path__ + "img/project9_17.png.50bc31c8.webp";